import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import request from 'utils/request_ajax';
import { hasFeatureFlags } from 'utils/features';
import StatusLabel from '../../shared/StatusLabel';
import HeaderDesigns from './HeaderDesigns';
import { HeaderStyle } from './types';

const SettingsLearnHeader = ({ activeLearnHeaderStyle, url }) => {
  const availableDesigns = {
    angle: t('settings.tab.customization.learn_header.angle'),
    swoop: t('settings.tab.customization.learn_header.swoop'),
    default: t('settings.tab.customization.learn_header.default'),
  };
  const [selectedDesign, setSelectedDesign] = useState(activeLearnHeaderStyle);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        setSuccess(false);
      }, 1500);
    }
  }, [success]);

  const updateLearnHeaderStyle = e => {
    if (e.target.value === selectedDesign) {
      return;
    }

    setError(false);
    setSelectedDesign(e.target.value);
    const settings = { learn_header_style: e.target.value };

    request
      .patchJSON(url, { company: { settings } })
      .then(() => {
        setSelectedDesign(settings.learn_header_style);
        setSuccess(true);
      })
      .catch((response, statusText, err) => {
        setError(true);
        setSelectedDesign(selectedDesign);
      });
  };

  const hasUnificationFeatureFlag = hasFeatureFlags([
    'readiness-enable-unification',
  ]);

  return (
    <div className="mb-24">
      {!hasUnificationFeatureFlag && (
        <>
          <div className="d-f mb-8">
            <p className="d-f ai-c jc-c mb-0 lh-24">
              {t('settings.tab.customization.learn_header.title')}
            </p>
            <StatusLabel success={success} error={error} />
          </div>
          <HeaderDesigns
            availableDesigns={availableDesigns}
            selectedDesign={selectedDesign}
            updateLearnHeaderStyle={updateLearnHeaderStyle}
          />
        </>
      )}
    </div>
  );
};

SettingsLearnHeader.propTypes = {
  url: PropTypes.string,
  activeLearnHeaderStyle: HeaderStyle,
};

export default SettingsLearnHeader;
